import { adminApi } from "../../lib/axios";

export interface AgencyBlogResponseDto {
  id: string;
  title: string;
  description: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateAgencyBlogInput {
  title: string;
  description: string;
}

export interface UpdateAgencyBlogInput {
  title?: string;
  description?: string;
}

export interface PaginatedAgencyBlogResponse {
  data: AgencyBlogResponseDto[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const adminAgencyBlogService = {
  async list(
    page: number = 1,
    limit: number = 10
  ): Promise<PaginatedAgencyBlogResponse> {
    try {
      const res = await adminApi.get(
        `/agency-blog?page=${page}&limit=${limit}`
      );
      return res.data;
    } catch (error: any) {
      console.error("Error fetching agency blogs:", error);
      return {
        data: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
          totalPages: 0,
        },
      };
    }
  },

  async getById(id: string): Promise<AgencyBlogResponseDto> {
    const res = await adminApi.get(`/agency-blog/${id}`);
    return res.data.data || res.data.item || res.data;
  },

  async create(input: CreateAgencyBlogInput): Promise<AgencyBlogResponseDto> {
    const res = await adminApi.post("/agency-blog", input);
    return res.data.data || res.data.item || res.data;
  },

  async update(
    id: string,
    input: UpdateAgencyBlogInput
  ): Promise<AgencyBlogResponseDto> {
    const res = await adminApi.patch(`/agency-blog/${id}`, input);
    return res.data.data || res.data.item || res.data;
  },

  async remove(id: string): Promise<{ success: boolean; message?: string }> {
    const res = await adminApi.delete(`/agency-blog/${id}`);
    return { success: true, message: res.data?.message };
  },
};

export default adminAgencyBlogService;
